"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commissionApi = void 0;
exports.commissionApi = (http, prefix = '/commission') => ({
    getCustomerCommission(id) {
        return http.get(`${prefix}/customer/${id}`);
    },
    getCustomerCommissionChannels(id) {
        return http.get(`${prefix}/customer/${id}/channels`);
    },
    getPropertyCommission(id) {
        return http.get(`${prefix}/property/${id}`);
    },
    getCustomerCommissionDeals(id) {
        return http.get(`${prefix}/customer/${id}/deal`);
    },
    getPropertyCommissionDeals(id) {
        return http.get(`${prefix}/property/${id}/deal`);
    },
});
//# sourceMappingURL=index.js.map